import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '@/auth/useAuth';
const Verify2FAPage = () => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { verifyOtp, resendOtp } = useAuth();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await verifyOtp(otp);
            navigate('/tasks', { replace: true });
        }
        catch (err) {
            setError(err?.response?.data?.message || 'Échec de la vérification');
        }
        finally {
            setLoading(false);
        }
    };
    const handleResend = async (e) => {
        e.preventDefault();
        try {
            await resendOtp();
            toast.success('Un nouveau code a été envoyé');
        }
        catch (err) {
            // Ignore errors on resend
        }
    };
    return (_jsxs("div", { className: "flex min-h-full flex-col justify-center px-6 py-12 lg:px-8", children: [_jsxs("div", { className: "sm:mx-auto sm:w-full sm:max-w-sm", children: [_jsx("h2", { className: "mt-10 text-center text-2xl font-bold tracking-tight text-gray-900", children: "V\u00E9rification 2FA" }), error && _jsx("p", { className: "text-red-500 text-sm mb-2", children: error })] }), _jsxs("div", { className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm", children: [_jsxs("form", { onSubmit: handleSubmit, className: "space-y-6", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "otp-code", className: "block text-sm", children: "Code" }), _jsx("input", { id: "otp-code", type: "text", inputMode: "numeric", maxLength: 6, value: otp, onChange: (e) => setOtp(e.target.value), className: "w-full border px-3 py-2 rounded", required: true })] }), _jsx("button", { type: "submit", disabled: loading, className: "w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700", children: loading ? 'Vérification...' : 'Vérifier' })] }), _jsx("div", { className: "mt-4 text-center", children: _jsx("a", { href: "#", onClick: handleResend, className: "text-indigo-600 hover:underline", children: "Renvoyer un code" }) })] })] }));
};
export default Verify2FAPage;
